// Libs
import React from 'react'
import PropTypes from 'prop-types'
import * as d3Selection from 'd3-selection'
import * as d3Geo from 'd3-geo'

// Turf
import bbox from '@turf/bbox'
import { point } from '@turf/helpers'
import distance from '@turf/distance'

// Data
const sampleData = {
  'type': 'Feature',
  'geometry': {
    'type': 'Polygon',
    'coordinates': [
      [
        [-118.34156765699998, 55.14303412100014],
        [-119.62314971099988, 54.9449423260001],
        [-119.995740652, 54.94719811300013],
        [-120.00017916399997, 55.40759080400005],
        [-121.15168445399996, 55.70188656600004],
        [-121.20910384799993, 56.53390347600015],
        [-119.23760734499996, 56.575899183000104],
        [-118.53223969799996, 56.59018136900016],
        [-117.18426511099989, 58.5998358650001],
        [-115.58288921599996, 58.642278739000176],
        [-115.56483716399993, 58.008611046000055],
        [-116.58374729599996, 58.02276664100003],
        [-116.8210894099999, 57.36815240700008],
        [-117.0425552779999, 56.62016380000017],
        [-116.2605013619999, 55.17592497000004],
        [-117.28891242199995, 55.03681808500011],
        [-118.23771380199992, 55.19145962700014],
        [-118.34156765699998, 55.14303412100014],
      ],
    ],
  },
}

// Exports
export class GeoJsonSvg extends React.Component {
  constructor () {
    super()

    this.setRef = this.setRef.bind(this)
  }

  componentWillUpdate () {
    // each update, flush the nodes of the chart - this isn't the best way - see the other example for better practice
    while (this.rootNode.firstChild) {
      this.rootNode.removeChild(this.rootNode.firstChild)
    }
  }

  componentDidMount () {
    this.setState({
      _isMounted: true,
    })
  }

  draw () {
    const { data = sampleData, postProcess } = this.props

    const [minX, minY, maxX, maxY] = bbox(data)

    const sw = point([minX, minY])
    const nw = point([minX, maxY])
    const se = point([maxX, minY])

    const width = Math.round(distance(sw, se, 'kilometers') * 1000)
    const height = Math.round(distance(sw, nw, 'kilometers') * 1000)

    const svg = d3Selection.select(this.rootNode)
      .attr('viewBox', `0 0 ${width} ${height}`)

    const center = d3Geo.geoCentroid(data)
    const projection = d3Geo.geoMercator()
      .scale(150)
      .center(center)
      .translate([width / 2, height / 2])

    const path = d3Geo.geoPath(projection)

    const bounds = path.bounds(data)
    const hscale = 150 * width / (bounds[1][0] - bounds[0][0])
    const vscale = 150 * height / (bounds[1][1] - bounds[0][1])
    const scale = (hscale < vscale) ? hscale : vscale
    const offset = [width - (bounds[0][0] + bounds[1][0]) / 2,
      height - (bounds[0][1] + bounds[1][1]) / 2]

    const projection2 = d3Geo.geoMercator()
      .center(center)
      .scale(scale)
      .translate(offset)

    const path2 = d3Geo.geoPath(projection2)

    try {
      const result = svg.selectAll('path')
        .data(data.features || [data])
        .enter()
        .append('path')
        .attr('d', path2)

      if (postProcess) {
        postProcess(result)
      }
    } catch (error) {
      console.error(error)
      return (
        <span>'(!)'</span>
      )
    }
  }

  setRef (node) {
    this.rootNode = node
  }

  render () {
    if (this.rootNode && this.state._isMounted) {
      this.draw()
    }

    const { width, height } = this.props
    const widthHeightProps = {}

    if (width != null) widthHeightProps.width = width
    if (height != null) widthHeightProps.height = height

    return (
      <svg
        {...widthHeightProps}
        preserveAspectRatio={this.props.preserveAspectRatio || 'xMidYMax meet'}
        ref={this.setRef}
        style={this.props.style}
      />
    )
  }
}

GeoJsonSvg.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  data: PropTypes.object,
  postProcess: PropTypes.func,
  style: PropTypes.object,
  preserveAspectRatio: PropTypes.string,
}

export default GeoJsonSvg
